import { Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from "@material-ui/core";
import { Delete, FileCopy, GetApp, Info, Subject, TableChart, Warning } from "@material-ui/icons";
import { Alert } from "@material-ui/lab";
import React, { useState } from "react";
import '../styles/Prompt.css';
import { generateConcatenatedFile } from "./Utils/Helpers";

export default function Message(props) {
  const [isTableView, setIsTableView] = useState(true);

  let clipboardData = props.role === 'model' || props.type === 'text' ? props.messageData : '';
  let textChunks = [];
  let recordCount = 0;

  if (props.role === 'model' && props.type !== 'text') {
    const outputArr = JSON.parse(props.messageData) ?? [];
    const headers = outputArr?.length ? Object.keys(outputArr[0]) : [];
    recordCount = outputArr.length;

    if (isTableView) {
      textChunks.push(
        <TableContainer key={props.id + '-table'} style={{overflow: "scroll", maxHeight: "600px"}}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                {headers?.map((h, index) => {
                  return (
                    <TableCell 
                      id="header" 
                      key={index} 
                      style={{
                        textDecoration: "none", 
                        borderRadius: "0px", 
                        borderRight: "1px solid #FFFFFF", 
                        borderLeft: "1px solid #FFFFFF", 
                        backgroundColor: "#142e3e", 
                        color: "#28c4fc"
                        }}
                      >
                      <b>{h}</b>
                    </TableCell>
                  )
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {outputArr?.map((d, i) => {

                if (i === outputArr.length - 1 && Object.keys(d)?.length < headers.length) {
                  return (<React.Fragment key={i}></React.Fragment>)
                }

                return (
                  <TableRow key={i}>
                    {headers?.map((col, c) => (
                      <TableCell key={c} style={{borderRight: "1px solid #FFFFFF", borderLeft: "1px solid #FFFFFF"}}>
                        {d[col]}
                      </TableCell>
                    ))}
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      );
    } else {
      textChunks.push(
        <pre key={props.id + '-text'} style={{overflowY: "scroll", maxHeight: "600px", whiteSpace: "pre-wrap", paddingRight: "5px", wordBreak: "break-all"}}>
          <code>
            {JSON.stringify(outputArr, null, 2)}
          </code>
        </pre>
      )
    }
  } else if (props.role === 'model' && props.type === 'text') {
    clipboardData = props.messageData;
    textChunks = props.messageData?.split('\n\n')?.map((text, index) => {
      return (
        <Typography key={props.id + '-' + index} style={{whiteSpace: "pre-wrap", wordBreak: "break-all"}} variant="body1" paragraph>{text}</Typography>
      )
    });
  } else {
    if (props.type !== 'text') {
      clipboardData = props.filename;
      textChunks.push(
        <Typography key={props.id} style={{margin: "0px", whiteSpace: "pre-wrap", wordBreak: "break-all"}} variant="body1" paragraph>{props.filename}</Typography>
      );
    } else {
      clipboardData = props.messageData;
      textChunks = props.messageData?.split('\n\n')?.map((text, index) => {
        return (
          <Typography key={props.id + '-' + index} style={{whiteSpace: "pre-wrap", wordBreak: "break-all"}} variant="body1" paragraph>{text}</Typography>
        )
      });
    }
  }

  let viewButton;
  let recordCountText;

  if (props.role === 'model' && props.type === 'json') {
    viewButton = isTableView ? (
      <Tooltip title="View As Text" aria-label="View As Text">
        <IconButton 
          size='small' 
          onClick={() => setIsTableView(false)}
          style={{marginRight: "10px", color: "inherit"}}
        >
          <Subject fontSize='small'/>
        </IconButton>
      </Tooltip>
    ) : (
      <Tooltip title="View As Table" aria-label="View As Table">
        <IconButton 
          size='small' 
          onClick={() => setIsTableView(true)}
          style={{marginRight: "10px", color: "inherit"}}
        >
          <TableChart fontSize='small'/>
        </IconButton>
      </Tooltip>
    );
    recordCountText = (
      <Typography variant="subtitle2" style={{marginRight: "10px", display: "inline-block", verticalAlign: "middle"}}>Records: {recordCount}</Typography>
    );
  } else {
    viewButton = undefined;
    recordCountText = undefined;
  }

  return (
    <Grid item className="ai_messageContainer" xs={12} style={{padding: "25px 10px", borderRadius: "10px", textAlign: props.role === 'user' ? 'right' : 'left'}}>
      <div className="ai_actionContainer">
        <Tooltip title={`Click to copy messageId: ${props.id}`} aria-label="Copy messageId">
          <IconButton 
            size='small' 
            onClick={() => navigator.clipboard.writeText(props.id)}
            style={{marginRight: "10px", color: "inherit"}}
          >
            <Info fontSize='small'/>
          </IconButton>
        </Tooltip>
        {/* { props.messageData.error ? (
            <Tooltip title={props.messageData.error} aria-label="Error">
              <IconButton 
                size='small' 
                style={{marginRight: "10px", color: "inherit"}}
              >
                <Warning fontSize='small'/>
              </IconButton>
            </Tooltip>
          ) : undefined 
        } */}
        { props.role === 'model' ? (
            <Tooltip title="Copy to clipboard" aria-label="Copy to clipboard">
              <IconButton 
                size='small' 
                onClick={() => navigator.clipboard.writeText(clipboardData)}
                style={{marginRight: "10px", color: "inherit"}}
              >
                <FileCopy fontSize='small'/>
              </IconButton>
            </Tooltip>
          ) : undefined 
        }
        <Tooltip title="Delete Message" aria-label="Delete Message">
          <IconButton 
            size='small' 
            onClick={() => props.deleteMessage(props.id)}
            style={{color: "inherit"}}
          >
            <Delete fontSize='small'/>
          </IconButton>
        </Tooltip>
      </div>
      <div style={{display: "inline-block", margin: "0px", minWidth: "400px", textAlign: "left", maxWidth: "100%"}}>
        { props.error ? (
            <Alert severity='error'>
              There was an error generating content. Please retry sending prompt.
            </Alert>
          ) : undefined
        }
        { props.role === 'user' ? (
            <div style={{padding: props.type !== 'text' ? "10px" : "10px 10px 0px", backgroundColor: props.type !== 'text' ? "#d6d6d6" : undefined, borderRadius: props.type !== 'text' ? "5px" : undefined}}>
              {textChunks}
            </div>
          ) : (
            <div style={{backgroundColor: "#d6d6d6", padding: "10px", borderTopLeftRadius: "5px", borderTopRightRadius: "5px"}}>
              {textChunks}
            </div>
          )
        }
        { props.role === 'user' ? (
            <div style={{padding: "10px", textAlign: 'right'}}>
              <Typography variant="subtitle2" style={{display: "inline-block", verticalAlign: "middle"}}>Tokens: {props.tokenCount ?? "--"}</Typography>
            </div>
          ) : (
            <Grid container alignContent='center' style={{backgroundColor: "#6f6f6f", color: "#FFFFFF", padding: "10px", borderBottomLeftRadius: "5px", borderBottomRightRadius: "5px", textAlign: 'left'}}>
              <Grid item xs={10}>
                <Tooltip title="Copy to clipboard" aria-label="Copy to clipboard">
                  <IconButton 
                    size='small' 
                    onClick={() => {navigator.clipboard.writeText(clipboardData)}}
                    style={{marginRight: "10px", color: "inherit"}}
                  >
                    <FileCopy fontSize='small'/>
                  </IconButton>
                </Tooltip>
                { props.type !== 'text' ? (
                    <Tooltip title="Download CSV" aria-label="Download CSV">
                      <IconButton 
                        size='small' 
                        onClick={() => generateConcatenatedFile([props.message], 'message-' + props.message.messageId)}
                        style={{marginRight: "10px", color: "inherit"}}
                      >
                        <GetApp fontSize='small'/>
                      </IconButton>
                    </Tooltip>
                  ) : undefined
                }
                {viewButton}
                {recordCountText}
                <Typography variant="subtitle2" style={{display: "inline-block", verticalAlign: "middle", marginRight: "10px"}}>Tokens: {props.tokenCount}</Typography>
                <Typography variant="subtitle2" style={{display: "inline-block", verticalAlign: "middle", marginRight: "10px"}}>Thinking Tokens: {props.thinkingTokenCount}</Typography>
              </Grid>
              <Grid item xs={2} style={{textAlign: "right"}}>
                <Typography variant="subtitle2" style={{display: "inline-block", verticalAlign: "middle"}}>{props.type}</Typography>
              </Grid>
            </Grid>
          )
        }
      </div>
    </Grid>
  )
}